// extracted by mini-css-extract-plugin
export default {"container":"ServiceSummaryModal_container__rwYxa","body":"ServiceSummaryModal_body__kvTy2","card":"ServiceSummaryModal_card__sJK6s","cardBody":"ServiceSummaryModal_cardBody__j2oq9"};